'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import emptyFunction from 'react-utils/emptyFunction';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import CreateFieldList from 'DesignEditorsUI/components/customWidgetEditor/sidebar/CreateFieldList';
import Small from 'UIComponents/elements/Small';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.main.fields.fieldsDropdown.${key}`;

export default class CreateFieldDropdown extends Component {
  constructor(...args) {
    super(...args);

    this.onFieldCreate = fieldType => {
      this.props.onFieldCreate(fieldType);
    };
  }

  render() {
    const buttonText = this.props.buttonText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('addField')
    });

    return /*#__PURE__*/_jsx(UIDropdown, {
      buttonClassName: this.props.isStyleTab ? 'add-style-field-dropdown' : 'add-field-dropdown',
      buttonSize: "extra-small",
      buttonText: /*#__PURE__*/_jsx(Small, {
        children: buttonText
      }),
      buttonUse: "link",
      className: "fields-dropdown",
      closeOnTargetLeave: true,
      menuWidth: 315,
      disabled: this.props.disabled,
      placement: "bottom left",
      children: /*#__PURE__*/_jsx(CreateFieldList, {
        customWidgetId: this.props.customWidgetId,
        onFieldCreate: this.onFieldCreate,
        isStyleTab: this.props.isStyleTab
      })
    });
  }

}
CreateFieldDropdown.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  buttonText: PropTypes.string,
  onFieldCreate: PropTypes.func,
  disabled: PropTypes.bool,
  isStyleTab: PropTypes.bool
};
CreateFieldDropdown.defaultProps = {
  buttonText: null,
  onFieldCreate: emptyFunction
};